<!-- 登录页面 -->
<template>
  <el-container class="bgStyle">
    <el-main class="main">
      <el-row class="content">
        <el-col :span="8" class="contentChild" :offset="8">
          <el-row>
            <el-col :span="24">
              <h2>账号登录</h2>
              <el-form label-position="top" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item prop="name">
                  <el-input prefix-icon="el-icon-user" type="text" show-word-limit clearable  v-model="ruleForm.name" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input prefix-icon="el-icon-menu" type="password" clearable v-model="ruleForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item class="noMarginBottom">
                  <el-button class="btnSty" type="primary" @click="submitForm('ruleForm')">登录</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="filings">
        <el-col :span="24"><a class="filingsChild" href="https://beian.miit.gov.cn/" target="_blank">津ICP备2022007707号-1</a></el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
  // 局部MD5引用
  import md5 from 'js-md5'
  export default {
    name: 'SignIn',
    data() {
      return {
        ruleForm: {
          'name': '',// name
          'password': '',// 密码
        },
        rules: {
          name: [
            { required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      // 登录
      submitForm(formName) {
        // 验证
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.login({
              name: this.ruleForm.name,
              password: md5(this.ruleForm.password),
            }).then(res => {
              if (res.data.status == 200) {
                sessionStorage.setItem("userName",res.data.data.name);
                sessionStorage.setItem("userId",res.data.data.id);
                sessionStorage.setItem("userPass",window.btoa(res.data.data.password));
                sessionStorage.setItem('token',res.data.token);
                // 提示信息
                this.$message({
                  message: "登录成功！",
                  type: 'success'
                });
                // 跳转页面
                this.$router.push({ name: "Public" });
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
                this.$router.push({ name: "SignIn" });
              }
            });
          }
        });
      },
      // 点击回车执行事件
      onKeyDownEnter() {
        let _self = this;
        document.onkeydown = function (e) {
          let theEvent = window.event || e;
          let code = theEvent.keyCode || theEvent.which || theEvent.charCode;
          if (code == 13) {
            _self.submitForm('ruleForm');
          }
        }
      }
    },
    mounted() {
      // 点击回车执行登录
      this.onKeyDownEnter();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/sign.css"; /* 管理平台样式 */
</style>



// WEBPACK FOOTER //
// src/components/Common/SignIn.vue